export const AnchorLinks = (function () {
	'use strict';

	let $win, $anchorLink;

	function init() {
		$win = jQuery(window);
		$anchorLink = $('a[href^="#"]');

		$win.on('load', function (e) {
			const hash = location.hash;
			if (hash && $(hash).length > 0 && !$(hash).hasClass('modal')) {
				scrollToEl(hash);
			}
		});

		$anchorLink.click(function (e) {
			let id = $(this).attr('href');
			if (id.length > 1 && $(id).length > 0 && !$(id).hasClass('modal')) {
				e.preventDefault();
				scrollToEl(id);
			}
		});
	}

	function scrollToEl(id) {
		const targetEl = document.getElementById(id.replace('#', ''));
		const DESKTOP_BREAKPOINT = 1024;
		const DESKTOP_OFFSET = 170;
		const MOBILE_OFFSET = 70;
		const isDesktop = document.body.offsetWidth >= DESKTOP_BREAKPOINT;
		const offset = isDesktop ? DESKTOP_OFFSET : MOBILE_OFFSET;
		const scrollTop = $(id).offset().top - offset;
		// $('html, body').animate({ scrollTop }, 1000);

		window.scrollTo({
			top: targetEl.offsetTop,
			behavior: 'smooth',
		});
	}

	return {
		init: init,
	};
})();
